import React, { useState } from "react";
import {
  MyMessage,
  InputField,
  Select,
  MyButton,
  AdModal,
  AddPageShell,
  AddSection,
} from "../../components/Component";
import { codeOk } from "../../../lib/index";
import { useDoSeeDataContext } from "../../../context/DoSeeDataContext";
import { getOneEvent } from "../../../lib/sysNavigation/SysNavigation";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../lib/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../components/Pricing";
import GenerateDescription from "../utils/GenerateDescription";
import {
  ContactSection,
  SocialSection,
  GeoSection,
  VisibilitySection,
  DescriptionSection,
} from "../utils/AddSections";
import {
  FiImage,
  FiClock,
  FiCalendar,
  FiDollarSign,
  FiRepeat,
  FiTarget,
} from "react-icons/fi";

const REPEAT_OPTIONS = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
  "annual",
];

const Edit = () => {
  const { updateOneContent } = useDoSeeDataContext();
  const event: any = getOneEvent();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const [showModal, setShowModal] = useState(false);
  const [thumbnail, setThumbnail] = useState<any>(event?.thumbnail);
  const [thumbnailId, setThumbnailId] = useState<any>(event?.image_cdn_id);
  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const event_id = event?.event_id;
  const [title, setTitle] = useState<any>(event?.title);
  const [venue, setVenue] = useState<any>(event?.venue);
  const [venueCapacity, setVenueCapacity] = useState<any>(event?.venue_capacity);
  const [startDate, setStartDate] = useState<any>(event?.start_date);
  const [endDate, setEndDate] = useState<any>(event?.end_date);
  const [startTime, setStartTime] = useState<any>(event?.start_time);
  const [endTime, setEndTime] = useState<any>(event?.end_time);
  const [email, setEmail] = useState<any>(event?.email_address);
  const [phoneNumber, setPhoneNumber] = useState<any>(event?.phone_number);
  const [whatsapp, setWhatsapp] = useState<any>(event?.whatsapp);
  const [facebook, setFacebook] = useState<any>(event?.facebook);
  const [twitter, setTwitter] = useState<any>(event?.twitter);
  const [instagram, setInstagram] = useState<any>(event?.instagram);
  const [youtube, setYoutube] = useState<any>(event?.youtube);
  const [hashtags, setHashtags] = useState<any>(event?.hashtag);
  const [repeatEvery, setRepeatEvery] = useState<any>(event?.repeat_every);
  const [googleMapCode, setGoogleMapCode] = useState<any>(event?.google_map_code);
  const [latitude, setLatitude] = useState<any>(event?.latitude);
  const [longitude, setLongitude] = useState<any>(event?.longitude);
  const [formattedAddress, setFormattedAddress] = useState<any>(
    event?.formatted_address
  );
  const [featured, setFeatured] = useState<any>(event?.featured);
  const [promoted, setPromoted] = useState<any>(
    event?.promoted ? event?.promoted : "no"
  );
  const [eventStatus, setEventStatus] = useState<any>(event?.status);
  const [description, setDescription] = useState<any>(event?.description);
  const [expo, setExpo] = useState<any>(event?.expo);
  const [showTop, setShowTop] = useState<any>(event?.show_top);
  const [pricing, setPricing] = useState<any>(event?.Pricings);
  const [payLink, setPayLink] = useState<any>(event?.pay_link);

  const [showDescriptionModal, setShowDescriptionModal] = useState<any>(null);

  const eventRoutes = "/data/event";

  const responses = (isError: any, message: any) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(message);
  };

  const updateOneEventHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id ? country_id : event?.country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: title?.toLowerCase().replace(/\s/g, "_"),
      description: description,
      city_level: "level_label",
      venue: venue,
      venue_capacity: venueCapacity,
      start_date: startDate,
      end_date: endDate,
      start_time: startTime,
      end_time: endTime,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: phoneNumber,
      email_address: email,
      whatsapp: whatsapp,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      hashtag: hashtags,
      audio_adv: "none",
      google_map_code: googleMapCode,
      latitude: latitude,
      longitude: longitude,
      formatted_address: formattedAddress,
      country_short: "none",
      status: eventStatus,
      featured: featured,
      promoted: promoted,
      repeat_every: repeatEvery,
      expo: expo,
      show_top: showTop,
      pricing,
      pay_link: payLink,
    };

    const { message, status } = await updateOneContent({
      data_id: event_id,
      data: data,
      content: _TYPES_.EVENT,
      position: {
        country_id,
        first_level_id,
        second_level_id,
        third_level_id,
        fourth_level_id,
      },
    });

    if (status === codeOk) responses(false, message);
    else responses(true, message);
  };

  const clearMessages = () => {
    setError(null as any);
    setSuccess(null as any);
  };

  const toggleRepeat = (val: string) => {
    if (repeatEvery?.toString().split("|").includes(val)) {
      let rep = "";
      repeatEvery
        ?.split("|")
        .filter((day: string) => val !== day)
        .forEach((weekday: string) => (rep += `${weekday}|`));
      setRepeatEvery(rep);
    } else {
      let rep = "";
      if (repeatEvery) {
        [...repeatEvery.split("|"), val].forEach(
          (weekday: string) => (rep += `${weekday}|`)
        );
        setRepeatEvery(rep);
      } else {
        setRepeatEvery(val);
      }
    }
  };

  return (
    <AddPageShell
      backRoute={eventRoutes}
      eyebrow="DoSee Data • Events"
      title="Edit Event"
      subtitle={`Update an event in ${entry_label || "this destination"}.`}
      icon={<FiCalendar className="h-5 w-5" />}
      headerActions={
        <MyButton
          title="Position Event"
          className="inline-flex items-center gap-2 rounded-lg bg-gradient-to-br from-brand to-primary px-3.5 py-2 text-xs font-semibold text-white shadow hover:opacity-95"
          onClick={() => setShowModal(true)}
        >
          <FiTarget className="h-4 w-4" />
          Position Event
        </MyButton>
      }
      modals={
        <>
          {showDescriptionModal ? (
            <GenerateDescription
              setDescription={setDescription}
              setShowDescriptionModal={setShowDescriptionModal}
            />
          ) : null}
          {showModal ? (
            <AdModal
              event_id={event_id}
              name={title}
              setShowModal={() => setShowModal(false)}
            />
          ) : null}
        </>
      }
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneEventHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Cover Image"
        hint="The hero image for this event."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={image_kit_folder(country_name, FOLDERS.EVENTS)}
        />
      </AddSection>

      <AddSection title="Event Details" hint="Title, venue and capacity.">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "title",
              title: "Title",
              type: "text",
              value: title || "",
              onChange: (e: any) => {
                setTitle(e.target.value);
                clearMessages();
              },
            }}
          />
          <Select
            props={{
              id: "top",
              title: "Show In Top Events",
              option: ["no", "yes"],
              preselect:
                showTop !== undefined && showTop !== null
                  ? [{ name: showTop === 1 ? "yes" : "no" }]
                  : null,
              onChange: (e: any) => {
                if (e.target.selectedIndex === 0) setShowTop(0);
                else setShowTop(1);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "venue",
              title: "Venue",
              type: "text",
              value: venue || "",
              onChange: (e: any) => {
                setVenue(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "venue_capacity",
              title: "Venue Capacity",
              type: "number",
              value: venueCapacity || "",
              onChange: (e: any) => {
                setVenueCapacity(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "formatted_address",
              title: "Formatted Address",
              type: "address",
              value: formattedAddress || "",
              onChange: (e: any) => {
                setFormattedAddress(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Date & Time"
        hint="When the event takes place."
        icon={<FiClock className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          <InputField
            props={{
              id: "start_date",
              title: "Start Date",
              type: "date",
              value: startDate || "",
              onChange: (e: any) => {
                setStartDate(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "end_date",
              title: "End Date",
              type: "date",
              value: endDate || "",
              onChange: (e: any) => {
                setEndDate(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "start_time",
              title: "Start Time",
              type: "time",
              value: startTime || "",
              onChange: (e: any) => {
                setStartTime(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "end_time",
              title: "End Time",
              type: "time",
              value: endTime || "",
              onChange: (e: any) => {
                setEndTime(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Repeat Schedule"
        hint="Optional — recurring days or annual."
        icon={<FiRepeat className="h-4 w-4" />}
      >
        <div className="flex flex-wrap gap-2">
          {REPEAT_OPTIONS.map((val) => {
            const on = repeatEvery?.toString().split("|").includes(val);
            return (
              <span
                key={val}
                role="button"
                tabIndex={0}
                onClick={() => toggleRepeat(val)}
                onKeyDown={(e) =>
                  (e.key === "Enter" || e.key === " ") && toggleRepeat(val)
                }
                className={`inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs cursor-pointer capitalize transition-colors ${
                  on
                    ? "border-brand bg-brand/10 text-brand"
                    : "border-gray-200 bg-white text-gray-700 hover:border-gray-300 hover:bg-gray-50"
                }`}
              >
                {on ? (
                  <MdCheckBox className="text-base" />
                ) : (
                  <MdCheckBoxOutlineBlank className="text-base" />
                )}
                {val}
              </span>
            );
          })}
        </div>
      </AddSection>

      <AddSection
        title="Pricing"
        hint="Optional pricing tiers."
        icon={<FiDollarSign className="h-4 w-4" />}
      >
        <Pricing pricing={pricing} setPricing={setPricing} />
      </AddSection>

      <ContactSection
        phone={phoneNumber}
        setPhone={setPhoneNumber}
        email={email}
        setEmail={setEmail}
        payLink={payLink}
        setPayLink={setPayLink}
        clearMessages={clearMessages}
      />

      <SocialSection
        whatsapp={whatsapp}
        setWhatsapp={setWhatsapp}
        facebook={facebook}
        setFacebook={setFacebook}
        twitter={twitter}
        setTwitter={setTwitter}
        instagram={instagram}
        setInstagram={setInstagram}
        youtube={youtube}
        setYoutube={setYoutube}
        clearMessages={clearMessages}
      />

      <GeoSection
        googleMapCode={googleMapCode}
        setGoogleMapCode={setGoogleMapCode}
        latitude={latitude}
        setLatitude={setLatitude}
        longitude={longitude}
        setLongitude={setLongitude}
        clearMessages={clearMessages}
      />

      <VisibilitySection
        statusId="event_status"
        setStatus={setEventStatus}
        setFeatured={setFeatured}
        setPromoted={setPromoted}
        setExpo={setExpo}
        status={eventStatus}
        featured={featured}
        promoted={promoted}
        expo={expo}
        clearMessages={clearMessages}
      />

      <DescriptionSection
        description={description}
        setDescription={setDescription}
        hashtags={hashtags}
        setHashtags={setHashtags}
        onGenerate={() => setShowDescriptionModal(true)}
        clearMessages={clearMessages}
      />
    </AddPageShell>
  );
};

export default Edit;
